/**
 * Tiefe faerbt sich selbst.
 *
 * Wasser schluckt Licht nach Wellenlaenge: Rot verschwindet in den ersten
 * Metern, dann Orange und Gelb, Blau reicht am tiefsten. Genau das ist hier
 * die Skala — sie bildet nicht irgendeine Farbrampe ab, sondern die Physik
 * des Gegenstands. Ein Wert von 5 m sieht warm aus, 45 m sieht kalt aus,
 * ohne dass jemand eine Legende lesen muss.
 */

/** Stuetzpunkte: Tiefe in Metern -> Farbe. Dazwischen wird interpoliert. */
export const SKALA = [
  { m: 0, rgb: [244, 182, 106] }, // Bernstein — Sonnenlicht in den ersten Metern
  { m: 12, rgb: [214, 156, 94] },
  { m: 20, rgb: [122, 178, 168] },
  { m: 30, rgb: [58, 158, 190] }, // Cyan — hier ist Rot laengst weg
  { m: 45, rgb: [46, 104, 168] },
  { m: 65, rgb: [52, 62, 128] }, // Indigo — tiefer als jeder Tauchgang im Bestand
];

const begrenzen = (wert, min, max) => Math.min(max, Math.max(min, wert));

/** Farbe fuer eine Tiefe, als `rgb(...)`. Ungueltige Werte werden zu Grau. */
export function tiefenfarbe(meter) {
  if (typeof meter !== 'number' || Number.isNaN(meter)) return 'rgb(120, 134, 148)';
  const tiefe = begrenzen(meter, 0, SKALA[SKALA.length - 1].m);
  let unten = SKALA[0];
  let oben = SKALA[SKALA.length - 1];
  for (let i = 0; i < SKALA.length - 1; i += 1) {
    if (tiefe >= SKALA[i].m && tiefe <= SKALA[i + 1].m) {
      unten = SKALA[i];
      oben = SKALA[i + 1];
      break;
    }
  }
  const spanne = oben.m - unten.m || 1;
  const anteil = (tiefe - unten.m) / spanne;
  const kanal = (i) => Math.round(unten.rgb[i] + (oben.rgb[i] - unten.rgb[i]) * anteil);
  return `rgb(${kanal(0)}, ${kanal(1)}, ${kanal(2)})`;
}

/**
 * Ein Verlauf ueber die Tiefe eines Tauchgangs — fuer Profil und Glyph.
 * `hoehe` ist die Zeichenhoehe in Pixeln, `maxTiefe` die Tiefe ganz unten.
 */
export function tiefenverlauf(ctx, hoehe, maxTiefe) {
  const verlauf = ctx.createLinearGradient(0, 0, 0, hoehe);
  const stufen = 6;
  for (let i = 0; i <= stufen; i += 1) {
    verlauf.addColorStop(i / stufen, tiefenfarbe((maxTiefe * i) / stufen));
  }
  return verlauf;
}
